import RequestAbstract from '../abstract';

export default class PublicMerchantTerminalPayoutRequests extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = 'api/public-merchant-terminal-payout-requests';
    }

    updateStatus = async (id, status) => {
        return await this.get(this.link + `/set/${id}/status/${status}`);
    };
}
